import { useEffect } from 'react'
import { useApolloClient } from '@apollo/client'
import { reconnectWs, setSessionExpiredHandler } from 'app/apollo-middlewares'
import { getPrivySessionBridge } from '../session-bridge'
import { createSessionExpiredHandler } from '../utils/create-session-expired-handler'
import { notifySessionExpired } from '../utils/exchange-toasts'

/**
 * Signs the user out of the app when the gateway reports the XYRO session
 * expired, then reopens it from a live Privy session, or asks to sign in
 * again. Mounted once at the app root.
 *
 * NOTE: Privy-free; the Privy session is reached through the session bridge.
 */
export const SessionExpiredEffect = () => {
  const client = useApolloClient()

  useEffect(() => {
    setSessionExpiredHandler(
      createSessionExpiredHandler({
        resetUser: () => {
          // NOTE: the active `me` queries refetch and get the anonymous answer
          client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'me' })
          client.cache.gc()
          reconnectWs()
        },
        restoreSession: () => {
          const bridge = getPrivySessionBridge()

          // NOTE: until Privy loads, its own login check on load reopens the
          // session for a returning user
          return bridge ? bridge.restoreSession() : Promise.resolve(true)
        },
        notifyExpired: notifySessionExpired
      })
    )

    return () => setSessionExpiredHandler(null)
  }, [client])

  return null
}
